import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { User } from 'src/app/users/models/user';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { UsersService } from '../users.service';
import { Perfil } from '../models/perfil';
import { LoaderService } from 'src/app/loader/loader.service';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-users-add',
  templateUrl: './users-add.component.html',
  styleUrls: ['./users-add.component.scss'],
})
export class UsersAddComponent implements OnInit {
  env;
  user: User;
  profiles: Perfil[];

  timeoutIDError;

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};

  @ViewChild('alertError', { read: ElementRef, static: false })
  alertError: ElementRef;

  constructor(
    private router: Router,
    private usersService: UsersService,
    private loaderService: LoaderService,
    private renderer: Renderer2,
    private permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  async ngOnInit() {
    this.setCompaniesDropdown();
    this.addNewUser();
    await this.handlePermissionsToGetPerfis();
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertError.nativeElement, 'hidden', false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, 'hidden', true);
    }, 8000);
  }

  onSubmit() {
    this.handleUserCompanies();
    this.addUser(this.env.selected.cnpj, this.user);
  }

  async addUser(cnpj: string, user: User) {
    const loader = await this.loaderService.notifica({
      title: 'Salvando usuário...',
      date: moment().toISOString(),
      type: 'loading',
    });

    const newUser = await this.usersService.addUser(cnpj, user).toPromise();

    if ('error' in newUser) {
      this.addErrorAlert(newUser.error);
    } else {
      this.router.navigateByUrl(`/users/${environment.selected.cnpj}`);
    }

    loader.dismiss();
  }

  addNewUser() {
    this.user = {
      nome: '',
      email: '',
      codigo_externo: '',
      ativo: true,
      empresas: [this.env.selected],
      novoPerfil: {
        nome: 'Operador',
        permissoes: {
          painel: [
            {
              codigo: 'cobrancaDist',
              descricao: 'Módulo de Distribuição de Cobranças',
              permitido: true,
            },
            {
              codigo: 'cobranca',
              descricao: 'Módulo de Cobrança',
              permitido: true,
            },
            {
              codigo: 'vendas',
              descricao: 'Módulo de Vendas',
              permitido: true,
            },
            {
              codigo: 'reports',
              descricao: 'Módulo de Equipes',
              permitido: true,
            },
            {
              codigo: 'reports',
              descricao: 'Módulo de Relatórios',
              permitido: true,
            },
          ],
          apps: [
            {
              codigo: 'app-cob',
              descricao: 'Aplicativo de Cobranças',
              permitido: true,
            },
            {
              codigo: 'app-vendas',
              descricao: 'Aplicativo de Vendas',
              permitido: true,
            },
          ],
          virtusservice: [
            {
              codigo: 'painel-tv',
              descricao: 'Painel de TV',
              permitido: true,
            },
          ],
        },
      },
    };
  }

  private handleUserCompanies() {
    this.user.empresas = this.user.empresas.map(empresa => {
      return this.env.user.empresas.filter(emp => emp.cnpj === empresa.cnpj)[0];
    });
  }

  private async handlePermissionsToGetPerfis() {
    const profiles = await this.usersService.getPerfis().toPromise();

    if (!this.permissionsService.isProfile('Master')) {
      this.profiles = profiles.filter(profile => profile.nome !== 'Master');
    } else {
      this.profiles = profiles;
    }
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'cnpj',
      textField: 'fantasia',
      selectAllText: 'Selecionar Todos',
      unSelectAllText: 'Deselecionar Todos',
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: 'Pesquisar',
    };
  }

  compareByName(itemOne, itemTwo) {
    return itemOne && itemTwo && itemOne.nome === itemTwo.nome;
  }

  goBack(): void {
    this.router.navigateByUrl(`/users/${this.env.selected.cnpj}`);
  }
}
